// Feature flags for the application
export const SHOW_SERVICE_DISRUPTION_BANNER = true;
export const SHOW_HANDBOOK_BANNER = false;
export const SHOW_DOWNLOAD_BANNER = true;
export const SHOW_REFERRAL_BANNER = false;
